<template>
  <div class="max-w-7xl p-4 mx-auto">
    <h1 class="text-2xl mt-2 mb-4">Departments</h1>
    <AppGrid v-if="!departmentAlphabeticalListView" data-test="dept-list" class="sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
      <AppCard
        v-for="(department,i) in departments"
        :key="i"
        :to="`/departments/${encodeURIComponent(department.id)}/overview`"
        :title="department.catalogDisplayName || department.displayName || 'Untitled Department'"
        :image="department.catalogImageUrl"
        :featured="!noDefaultImage"
      />
    </AppGrid>
    <div v-if="departmentAlphabeticalListView" class="lg:w-3/4 w-full mr-4">
        <div v-for="(departmentGroup,i) in departmentsGroup" :key="i">
          <h1 class="text-2xl text-black mt-2 mb-4">{{ departmentGroup.group }}</h1>
          <ul v-for="(department,index) in departmentGroup.children" :key="index" class="ml-4 list-disc list-inside">
            <li class="color-theme-light">
              <nuxt-link
                class="color-theme-light hover:color-theme-base transition-all duration-300 ease-in-out underline nuxt-link-exact-active nuxt-link-active"
                :to="`/departments/${encodeURIComponent(department.id)}/overview`"
              >
                {{ department.catalogDisplayName || department.displayName || 'Untitled Department' }}
              </nuxt-link>
            </li>
          </ul>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import useFeatureFlags from '@/composables/useFeatureFlags'
import {
  NO_DEFAULT_IMAGE,
  DEPARTMENT_LANDING_PAGE_ALPHABETICAL_LIST_VIEW,
} from '@/constants/featureFlags'
import AppGrid from '~contemporaryTheme/components/Base/AppGrid'
import AppCard from '~contemporaryTheme/components/Base/AppCard'
import { groupDepartmentAlphabetically } from '@/utils/departmentGroup'

export default {
  components: {
    AppGrid,
    AppCard,
  },
  setup() {
    const { noDefaultImage, departmentAlphabeticalListView } = useFeatureFlags({
      noDefaultImage: NO_DEFAULT_IMAGE,
      departmentAlphabeticalListView: DEPARTMENT_LANDING_PAGE_ALPHABETICAL_LIST_VIEW,
    })
    return { noDefaultImage, departmentAlphabeticalListView }
  },
  computed: {
    ...mapState('departments', {
      departments: (state) => state.chosen || state.all,
      departmentsGroup: (state) =>
        groupDepartmentAlphabetically(state.chosen || state.all),
    }),
  },
}
</script>

<style scoped>
h1 {
  color: var(--h1HeaderFontColor, var(--text-gray-900));
  font-family: var(--h1HeaderFontTypeface, inherit);
  font-weight: var(--h1HeaderFontWeight, 700);
}
</style>
